// extracted by mini-css-extract-plugin
export var cookiePolicy = "style-module--cookie-policy--fe4a8";